require("expose-loader?exposes=DMS!./_Public");
// require("expose-loader?$dms!./_Selector");

require("./CustomConfiguration.js");
